/* eslint-disable */
// @ts-nocheck
import axios from "axios";
import store from "../../store/index";
import { h } from "vue";

/* ------------ helpers shared by both components ------------- */
function inlineColorStyle(color) {
  const c = (color || "").toString().trim();
  return c ? { borderLeft: "4px solid " + c } : {};
}

function statusClassFromText(statusText) {
  const s = (statusText || "").toString().trim().toLowerCase();
  if (!s || /\bunchanged\b|no\s*change/.test(s)) return {};
  if (/\bnew\b|\badded\b/.test(s)) return { added: true };
  if (/\bremoved\b|\bdeleted\b/.test(s)) return { removed: true };
  if (/\bmodified\b|update(?:d)?\b|\bchange(?:d)?\b/.test(s)) return { modified: true };
  return {};
}

/* ---------------- Recursive item for Activities + Forms ---------------- */
const ActivityItem = {
  name: "ActivityItem",
  props: { node: { type: Object, required: true }, idx: { type: Number, default: 0 } },
  methods: { inlineColorStyle, statusClassFromText },
  render() {
    const n = this.node || {};
    const forms = Array.isArray(n.forms) ? n.forms : [];
    return h(
      "li",
      {
        class: this.statusClassFromText(n.status),
        style: this.inlineColorStyle(n.color),
        key: (n.activityName || "") + ":" + this.idx
      },
      [
        h("details", { open: !!n.open }, [
          h("summary", null, "Activity: " + (n.activityName || "")),
          h("ul", { class: "activity" },
            forms.map((f, fi) =>
              h(
                "li",
                {
                  class: ["form", this.statusClassFromText(f.status)],
                  style: this.inlineColorStyle(f.color),
                  key: (f.formName || "") + ":" + fi
                },
                "Form: " + (f.formName || "")
              )
            )
          )
        ])
      ]
    );
  }
};

export default {
  name: "studyversiondiff",
  components: { ActivityItem },

  props: {
    baseurl: { type: String, default: "" },
    studyIdProp: { type: String, default: "" }
  },

  data() {
    return {
      versionList: [],
      selectedVersionNew: "",
      selectedVersionOld: "",
      spinner: false,
      tempoldversion:"",
      tempnewversion:"",
      // Keep payloads exactly as the API returns them
      leftVersionData:  { version: "Old", visits: [] },
      rightVersionData: { version: "New", visits: [] }
    };
  },
watch: {
       selectedVersionOld(newVal, oldVal) {
      this.tempoldversion = oldVal;
    },
    selectedVersionNew(newVal, oldVal) {
      this.tempnewversion = oldVal;
    },
  },
  computed: {
    apiBase() {
      return this.baseurl || process.env.VUE_APP_Service_URL || "";
    },
    authToken() {
      try { return store.getters.getIdToken; } catch { return ""; }
    },
    currentStudyId() {
      try { return store.getters.getStudyIs || store.getters.getStudyId || this.studyIdProp; }
      catch { return this.studyIdProp; }
    },
    // Your template reads left/right
    left()  { return this.leftVersionData;  },
    right() { return this.rightVersionData; }
  },

  async mounted() {
    await this.listVersionTypes();
    await this.compareStudyVersions();

    window.addEventListener("studyIdChanged", async () => {
      await this.listVersionTypes();
      await this.compareStudyVersions();
    });
  },

  methods: {
    inlineColorStyle,
    statusClass(statusText) { return statusClassFromText(statusText); },

    async listVersionTypes() {
      const head = {
        headers: {
          Authorization: "Bearer " + this.authToken,
          "Content-Type": "application/json"
        }
      };
      try {
        const res = await axios.get(this.apiBase + "/management/study/studyversionlist", {
          ...head,
          params: { studyId: this.currentStudyId, isActive: true }
        });
        this.versionList = Array.isArray(res?.data) ? res.data : [];
        const n = this.versionList.length;
        this.selectedVersionNew = n ? this.versionList[n - 1] : "";
        this.selectedVersionOld = n > 1 ? this.versionList[n - 2] : this.selectedVersionNew;
        try { store.dispatch("setlatestversion", this.selectedVersionNew); } catch {}
      } catch (e) {
        console.error("version list failed:", e);
        this.versionList = [];
        this.selectedVersionNew = "";
        this.selectedVersionOld = "";
      }
    },
async validateandloadGraph(oldornew){
      console.log()
      let oldindex = this.versionList.indexOf(this.selectedVersionOld);
      let newindex = this.versionList.indexOf(this.selectedVersionNew);
      if(newindex > oldindex){
        this.compareStudyVersions();
      }
      else{
        
        alert("Invalid selection. The New Version must be later than the Old Version.");
        if(oldornew == "old"){
        this.selectedVersionOld = this.tempoldversion;
        }
        else{
        this.selectedVersionNew =  this.tempnewversion;
        }
      }
    },
    async compareStudyVersions() {
      if (!this.selectedVersionNew) {
        this.leftVersionData  = { version: "Old", visits: [] };
        this.rightVersionData = { version: "New", visits: [] };
        return;
      }

      this.spinner = true;
      const head = {
        headers: {
          Authorization: "Bearer " + this.authToken,
          "Content-Type": "application/json"
        }
      };

      try {
        const [newRes, oldRes] = await Promise.all([
          axios.get(this.apiBase + "/management/graph/comparednewstudyversiontreeinfo", {
            ...head,
            params: {
              studyId: this.currentStudyId,
              oldStudyVersion: this.selectedVersionOld,
              newStudyVersion: this.selectedVersionNew
            }
          }),
          axios.get(this.apiBase + "/management/graph/comparedoldstudyversiontreeinfo", {
            ...head,
            params: {
              studyId: this.currentStudyId,
              oldStudyVersion: this.selectedVersionOld,
              newStudyVersion: this.selectedVersionNew
            }
          })
        ]);

        // Save the API payloads directly (tiny guards so template never breaks)
        this.rightVersionData = {
          version: String(newRes?.data?.version || this.selectedVersionNew || "New"),
          studyId: newRes?.data?.studyId,
          visits: Array.isArray(newRes?.data?.visits) ? newRes.data.visits : []
        };
        this.leftVersionData = {
          version: String(oldRes?.data?.version || this.selectedVersionOld || "Old"),
          studyId: oldRes?.data?.studyId,
          visits: Array.isArray(oldRes?.data?.visits) ? oldRes.data.visits : []
        };
      } catch (e) {
        console.error("compare failed:", e);
        this.rightVersionData = { version: "New", visits: [] };
        this.leftVersionData  = { version: "Old", visits: [] };
      } finally {
        this.spinner = false;
      }
    }
  }
};
